import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AtecoCodeInterface } from '@app/interface/ateco-code';

@Component({
  selector: 'izy-ateco-code-selector-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './ateco-code-selector-dialog.component.html',
  styleUrl: './ateco-code-selector-dialog.component.scss',
})
export class AtecoCodeSelectorDialogComponent {
  searchTerm: string = '';
  filteredAtecoCodes: AtecoCodeInterface[] = [];
  selectedAtecoCodeId: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<AtecoCodeSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      atecoCodes: AtecoCodeInterface[];
      currentAtecoCodeId: number | null;
    },
  ) {
    this.filteredAtecoCodes = [...data.atecoCodes];
    this.selectedAtecoCodeId = data.currentAtecoCodeId;
  }

  filterAtecoCodes(): void {
    if (!this.searchTerm.trim()) {
      this.filteredAtecoCodes = [...this.data.atecoCodes];
      return;
    }

    const searchLower = this.searchTerm.toLowerCase();
    this.filteredAtecoCodes = this.data.atecoCodes.filter(
      (code) =>
        code.name?.toLowerCase().includes(searchLower) ||
        code.ateco_division?.toLowerCase().includes(searchLower) ||
        code.ateco_class?.toLowerCase().includes(searchLower) ||
        code.ateco_subcategory?.toLowerCase().includes(searchLower) ||
        `${code.ateco_division || ''}.${code.ateco_class || ''}.${code.ateco_subcategory || ''}`.includes(
          searchLower,
        ),
    );
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.selectedAtecoCodeId) {
      const selectedCode = this.data.atecoCodes.find(
        (c) => c.id === this.selectedAtecoCodeId,
      );
      this.dialogRef.close(selectedCode);
    }
  }
}
